/* Languages offered in the profile picker, by their English names. Anything not
   here can still be typed in and kept — this list is for finding, not policing. */
export const LANGUAGES = [
  'Afrikaans', 'Albanian', 'Amharic', 'Arabic', 'Armenian', 'Assamese', 'Azerbaijani',
  'Basque', 'Belarusian', 'Bengali', 'Bikol', 'Bosnian', 'Bulgarian', 'Burmese',
  'Catalan', 'Cebuano', 'Chichewa', 'Chinese (Cantonese)', 'Chinese (Mandarin)', 'Croatian', 'Czech',
  'Danish', 'Dari', 'Dutch', 'English', 'Estonian', 'Filipino', 'Finnish', 'French',
  'Galician', 'Georgian', 'German', 'Greek', 'Gujarati', 'Haitian Creole', 'Hausa', 'Hawaiian',
  'Hebrew', 'Hiligaynon', 'Hindi', 'Hungarian', 'Icelandic', 'Igbo', 'Ilocano', 'Indonesian',
  'Irish', 'Italian', 'Japanese', 'Javanese', 'Kannada', 'Kapampangan', 'Kazakh', 'Khmer',
  'Kinyarwanda', 'Korean', 'Kurdish', 'Kyrgyz', 'Lao', 'Latvian', 'Lithuanian',
  'Luxembourgish', 'Macedonian', 'Malagasy', 'Malay', 'Malayalam', 'Maltese', 'Maori',
  'Marathi', 'Mongolian', 'Nepali', 'Norwegian', 'Odia', 'Pangasinan', 'Pashto', 'Persian',
  'Polish', 'Portuguese', 'Punjabi', 'Quechua', 'Romanian', 'Russian', 'Samoan',
  'Scottish Gaelic', 'Serbian', 'Sesotho', 'Shona', 'Sindhi', 'Sinhala', 'Slovak',
  'Slovenian', 'Somali', 'Spanish', 'Sundanese', 'Swahili', 'Swedish', 'Swiss German',
  'Tagalog', 'Tajik', 'Tamil', 'Tatar', 'Telugu', 'Thai', 'Tibetan', 'Tigrinya', 'Tongan',
  'Turkish', 'Turkmen', 'Ukrainian', 'Urdu', 'Uyghur', 'Uzbek', 'Vietnamese', 'Waray',
  'Welsh', 'Wolof', 'Xhosa', 'Yiddish', 'Yoruba', 'Zulu',
];

/* The profile stores languages as one string ("English, German"). Older
   profiles used other separators ("EN / FIL"), so split on any of them. */
export function parseLanguages(value) {
  return [...new Set(
    (value || '').split(/[,/;|]+/).map((s) => s.trim()).filter(Boolean)
  )];
}

export function formatLanguages(list) {
  return [...list].sort((a, b) => a.localeCompare(b)).join(', ');
}
